module.exports = __webpack_public_path__ + "static/media/owl-2.60feb9aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/owl-2.png
// module id = 198
// module chunks = 0